import React from "react";
import { Tag } from "antd";

import {
  getTransactionStatusLabel,
  getTransactionStatusColor,
} from "./TransactionStatusTag";

type Props = {
  status: string;
};

const DistributionStatusTag = ({ status }: Props): JSX.Element => {
  const label = getTransactionStatusLabel(status);
  const color = getTransactionStatusColor(status);

  return (
    <Tag
      color={color}
      bordered={false}
    >
      {label}
    </Tag>
  );
};

export default DistributionStatusTag;
